<template>
    <div class="mt-0 mx-2 lg:mx-0">
        <div v-if="hasHeading" class="px-2 py-4 sm:px-1">
            <h2 class="text-gray-900 text-xl font-medium leading-6">
                <slot name="heading"></slot>
            </h2>
            <p v-if="hasSubheading" class="mt-1 max-w-2xl text-gray-500 text-sm">
                <slot name="subheading"></slot>
            </p>
        </div>

        <ul v-if="posts.length" class="pb-10 space-y-4" ref="feedList">
            <li v-for="post in posts" :key="post.id" class="flex">
                <feed-card :post="post" @confirm-delete="confirmDelete" ref="feedCards"></feed-card>
            </li>
        </ul>

        <transition name="fade">
            <div v-if="!posts.length">
                <div class="mt-4 w-full text-center p-10">
                    <p class="text-gray-600 text-lg">No Challenges Yet</p>
                    <p class="text-sm text-gray-500">Create a new challenge or check back later!</p>
                </div>
            </div>
        </transition>

        <!-- Delete Post Modal -->
        <!--<delete-post-modal :post.sync="deletingPost"></delete-post-modal>-->
    </div>
</template>

<script>
import FeedCard from "@/Pages/Dashboard/FeedCard"
import NoResults from "@/Jetstream/NoResults"
import DeletePostModal from "@/Pages/Post/DeletePostModal"
import Tooltip from "@/Components/Tooltip"

export default {
    components: {
        Tooltip,
        DeletePostModal,
        NoResults,
        FeedCard,
    },

    beforeDestroy() {
        window.onscroll = null
    },

    mounted() {
        this.loadMorePosts()
    },

    props: {
        data: {
            default: null,
            type: Object,
        },
    },

    computed: {
        hasHeading() {
            return !!this.$slots.heading
        },
        hasSubheading() {
            return !!this.$slots.subheading
        },
        nextUrl() {
            return this.links.next
        },
        lastCard() {
            return this.$refs.feedCards[Object.keys(this.posts).length - 1]
        },
    },

    data() {
        return {
            deletingPost: null,
            reportingPost: null,
            posts: this.data.data,
            links: this.data.links,
            isLoading: false,
        }
    },

    methods: {
        confirmDelete(post) {
            this.deletingPost = post
        },

        confirmReport(post) {
            this.reportingPost = post
        },

        loadMorePosts() {
            const threshold = 700 // Set the threshold in pixels
            window.onscroll = () => {
                let bottomOfWindow = document.documentElement.offsetHeight - (document.documentElement.scrollTop + window.innerHeight)

                // Check if the distance to the bottom is within the threshold
                if (bottomOfWindow <= threshold && this.nextUrl) {
                    let initialScrollTop = document.documentElement.scrollTop

                    // Make sure to prevent duplicate requests
                    if (!this.isLoading) {
                        this.isLoading = true

                        axios.get(this.nextUrl).then((response) => {
                            this.posts.push(...response.data.data)
                            this.links = response.data.links
                            this.isLoading = false

                            this.$nextTick(() => {
                                window.scrollTo({ left: 0, top: initialScrollTop })
                            })
                        })
                    }
                }
            }
        },
    },
}
</script>
